module.exports = __webpack_public_path__ + "static/img/US@3x.95003f1c.jpg";